export default "__VITE_ASSET__shqQO_OI__";